// Countries of the "Global presence" map on the website's Contact Us page.
// They are stored as branches (same list as the Syrian branches) whose
// `description` holds a small JSON with type "country".

// What the website shows while no country has been saved from the dashboard.
export const DEFAULT_COUNTRIES = [
  { name_ar: "سوريا", name_en: "Syria", city_ar: "المقر الرئيسي", city_en: "Headquarters", lat: 35.0, lng: 38.5, hq: true },
  { name_ar: "السعودية", name_en: "Saudi Arabia", city_ar: "الرياض", city_en: "Riyadh", lat: 23.88, lng: 45.08, hq: false },
  { name_ar: "الإمارات", name_en: "UAE", city_ar: "دبي", city_en: "Dubai", lat: 24.2, lng: 54.3, hq: false },
  { name_ar: "ألمانيا", name_en: "Germany", city_ar: "برلين", city_en: "Berlin", lat: 51.16, lng: 10.45, hq: false },
  { name_ar: "النمسا", name_en: "Austria", city_ar: "فيينا", city_en: "Vienna", lat: 47.6, lng: 14.55, hq: false },
  { name_ar: "بريطانيا", name_en: "United Kingdom", city_ar: "لندن", city_en: "London", lat: 54.0, lng: -2.5, hq: false },
  { name_ar: "ماليزيا", name_en: "Malaysia", city_ar: "كوالالمبور", city_en: "Kuala Lumpur", lat: 4.2, lng: 101.98, hq: false },
  { name_ar: "أستراليا", name_en: "Australia", city_ar: "سيدني", city_en: "Sydney", lat: -25.27, lng: 133.77, hq: false },
];

// branches.description is VARCHAR(191), branches.name VARCHAR(30)
export const MAX_DESCRIPTION_LENGTH = 191;

const round = (value) => Math.round(Number(value) * 1e5) / 1e5;

export const parseLocation = (location) => {
  try {
    const parsed = JSON.parse(location);
    const lat = Number(parsed?.lat);
    const lng = Number(parsed?.lng);
    return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;
  } catch (e) {
    return null;
  }
};

// Returns the country stored in a branch row, or null for a normal branch.
export const parseCountry = (branch) => {
  try {
    const data = JSON.parse(branch?.description);
    if (data?.type !== "country") return null;
    const location = parseLocation(branch.Location) || {};
    return {
      name_ar: data.ar || "",
      name_en: data.en || "",
      city_ar: data.city_ar || "",
      city_en: data.city_en || "",
      hq: Boolean(data.hq),
      lat: location.lat,
      lng: location.lng,
    };
  } catch (e) {
    return null;
  }
};

export const countryDescription = (country) =>
  JSON.stringify({
    type: "country",
    ar: country.name_ar.trim(),
    en: country.name_en.trim(),
    city_ar: country.city_ar.trim(),
    city_en: country.city_en.trim(),
    hq: Boolean(country.hq),
  });

export const countryToBranch = (country) => ({
  name: (country.name_en.trim() || country.name_ar.trim()).slice(0, 30),
  description: countryDescription(country),
  Location: JSON.stringify({ lat: round(country.lat), lng: round(country.lng) }),
  additional_fees: 0,
  openings_time: "-",
  phone_number: "-",
  fax: "-",
  delivery_time: "-",
});
